import script from "./CardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CardHeader.vue?vue&type=style&index=0&id=5232a7a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5232a7a6"]])

export default __exports__